import React, { useState } from 'react';
import logo from '../../Assets/logo-app.png'; 
import './register.css';
import Menu from '../Menu/menu';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';


const RegisterForm = () => {
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [ci, setCi] = useState('');
  const [email, setEmail] = useState('');
  const [date_of_birth, setDateOfBirth] = useState('');
  const [salary, setSalary] = useState('');
  const [company, setCompany] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState('');
  const [popUpStyle, setPopUpStyle] = useState('');

  const handleRegisterForm = async (e) => {
    e.preventDefault();

    if (!name || !surname || !ci || !email || !date_of_birth || !salary || !company) {
      setErrorMessage('Por favor, complete todos los campos.');
      setPopUpMessage('Por favor, complete todos los campos.');
      setPopUpStyle('error-popup');
      return;
    }

    if (ci.length !== 8 || !/^\d*$/.test(ci)) {
      setErrorMessage('Por favor, revise y complete la cédula correctamente.');
      setPopUpMessage('Por favor, revise y complete la cédula correctamente.');
      setPopUpStyle('error-popup');
      return;
    }
    
    if (!validateEmail(email)) {
      setErrorMessage('Por favor, revise y complete el correo electrónico correctamente.');
      setPopUpMessage('Por favor, revise y complete el correo electrónico correctamente.');
      setPopUpStyle('error-popup');
      return;
    }
    
    if (!/^[a-zA-Z\s]*$/.test(name)) {
      setErrorMessage('Por favor, revise y complete el nombre correctamente.');
      setPopUpMessage('Por favor, revise y complete el nombre correctamente.');
      setPopUpStyle('error-popup');
      return;
    }
    
    if (!/^[a-zA-Z\s]*$/.test(surname)) {
      setErrorMessage('Por favor, revise y complete el apellido correctamente.');
      setPopUpMessage('Por favor, revise y complete el apellido correctamente.');
      setPopUpStyle('error-popup');
      return;
    }
    
    if (parseFloat(salary) <= 0 || !/^\d*$/.test(salary)) {
      setErrorMessage('Por favor, revise y complete el salario correctamente.');
      setPopUpMessage('Por favor, revise y complete el salario correctamente.');
      setPopUpStyle('error-popup');
      return;
    }

    setErrorMessage('');

    try {
      const response = await fetch('https://z3tr309yf9.execute-api.us-east-1.amazonaws.com/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          surname,
          ci,
          email,
          date_of_birth,
          salary: parseFloat(salary),
          company,
        }),
      });
  
      if (response.ok) {
        setShowMessage(true);
        setPopUpMessage(`Nuevo empleado\n<b>${name} ${surname}</b>\nregistrado exitosamente!`);
        setPopUpStyle('success-popup');
      } else {
        setErrorMessage('Un error a ocurrido. Por favor, intente nuevamente.');
        setPopUpMessage('Un error a ocurrido. Por favor, intente nuevamente.');
        setPopUpStyle('error-popup');
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('Error de conexión.');
      setPopUpMessage('Error de conexión.');
      setPopUpStyle('error-popup');
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setName(value);
    } else {
      setErrorMessage('El nombre solo puede contener letras.');
    }
  };
  
  const handleSurnameChange = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setSurname(value);
    } else {
      setErrorMessage('El apellido solo puede contener letras.');
    }
  };

  const handleCiChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) { 
      setCi(value);
    } else {
      setErrorMessage('La cédula solo puede contener números.');
    }
  };

  const handleSalaryChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) { 
      setSalary(value);
    } else {
      setErrorMessage('La salario solo puede contener números.');
    }
  };

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };
  
  return (
    <div className="employee-form-container">
      <header>
        <img src={logo} alt="EasyPay Logo" className="login-logo-app"/>
        <h2>Información del empleado</h2>
      </header>
      <form className="register-form" onSubmit={handleRegisterForm} >
        <div className="form-group">
          <label>Nombre</label>
          <input 
            type="text" 
            placeholder="Ingrese el nombre" 
            value={name} 
            onChange={(e) => handleNameChange(e)} 
          />
        </div>
        <div className="form-group">
          <label>Apellido</label>
          <input 
            type="text" 
            placeholder="Ingrese el apellido" 
            value={surname} 
            onChange={(e) => handleSurnameChange(e)} 
          />
        </div>
        <div className="form-group">
          <label>Cédula de identidad</label>
          <input 
            type="text" 
            placeholder="Ingrese la cédula" 
            value={ci} 
            onChange={(e) => handleCiChange(e)} 
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input 
            type="email" 
            placeholder="Ingrese el email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
          />
        </div>
        <div className="form-group">
          <label>Fecha de nacimiento</label>
          <input 
            type="date" 
            value={date_of_birth} 
            onChange={(e) => setDateOfBirth(e.target.value)} 
          />
        </div>
        <div className="form-group">
          <label>Salario</label>
          <input 
            type="float64" 
            placeholder="Ingrese el salario" 
            value={salary} 
            onChange={(e) => handleSalaryChange(e)} 
          />
        </div>
        <div className="form-group">
          <label>Empresa</label>
          <input 
            type="text" 
            placeholder="Ingrese la empresa" 
            value={company} 
            onChange={(e) => setCompany(e.target.value)} 
          />
        </div>
        <button type="submit" className="submit-btn">Guardar</button>
      </form>

      {popUpMessage && <div className="blur-background"></div>}

      {popUpMessage && (
        <div className={`popup ${popUpStyle}`}>
          <CloseIcon 
            onClick={() => setPopUpMessage('')} 
            style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', color: 'black' }} 
          />
          {popUpStyle === 'success-popup' ? <CheckCircleIcon style={{ fontSize: '2.5em', marginBottom: '10px', color: 'green' }} /> : <ErrorIcon style={{ fontSize: '2.5em', marginBottom: '10px', color: 'white' }} />}
          <p dangerouslySetInnerHTML={{ __html: popUpMessage }}></p>
        </div>
      )}
      <Menu/>
    </div>
  );
};

export default RegisterForm;
